import axios from "axios";
import Logger from "@/api/Logger";

let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";

let axiosInstance = axios.create({
    baseURL: `${secure}${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}`,
    timeout: 10000,
});

export function getTranslations() {
    return axiosInstance.get('/api/services-new/translations/identifiers/all/hello-romania.json')
        .catch(error => {
            Logger.error(error.message, error.stack).then(() => null);
        });
}